import { Observable, of, throwError } from 'rxjs';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { catchError, tap, map } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { SharedService } from './shared.service';
import{ GlobalConstants } from '../common/global-constants';
const apiUrl = GlobalConstants.apiURL
@Injectable({
  providedIn: 'root'
})
export class PatientService {

  constructor(private http:HttpClient, private sharedapi:SharedService) { }

  getPatientList(pageno,limit,qstring)
  {
      let webheader = this.sharedapi.getHeaders();
      return this.http.get(apiUrl+'get-patient-list/'+limit+'/'+pageno+'?'+qstring,{headers:webheader})
  }

  getWalletEditData(glamyo_patient_id)
  {
      let webheader = this.sharedapi.getHeaders();
      return this.http.get(apiUrl+'get-update-wallet-data/'+glamyo_patient_id,{headers:webheader})
  }
  
  saveEditWallet(data)
  {
      let webheader = this.sharedapi.getHeaders();
      return this.http.post(apiUrl+'save-edit-wallet-data',data,{headers:webheader})
  }

}
